import React, {useState, useEffect} from "react"
import { Div, Text, Container } from "atomize";
import { siteTitle } from "../../../Constants/constants";
import { baseUrl } from "../../../Constants/constants";
import styled from "styled-components";
import theme from "../../../Theme/Theme";
import Fade from 'react-reveal/Fade';
import {PrimaryButton} from "../../Atoms/Button";
import Logo from "./../../../Assets/branding/logo2.png";
import Blur from "./../../../Assets/branding/blur.png";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import useWindowSize from "../../../utils/useWindowSize";
import PlayIcon from "./../../../Assets/Icons/play.svg";
import PauseIcon from "./../../../Assets/Icons/pause.svg";
import ReactPlayer from "react-player";
import HeroVideoMedium from "./../../../Assets/videos/final_sm_2.mp4";
import HeroVideoSmall from "./../../../Assets/videos/final_v_sm_2.mp4";
import HeroVideoLarge from "./../../../Assets/videos/final_2.mp4";

const Main = styled.div`
  position: relative;
  overflow: hidden;
  .skeleton-hero {
    > div, > div > span, > div > span > span {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: -1;
      border-radius: 0;
    }
  }
  
  &:before {
      background-color: ${theme.colors.primary};
      content: "";
      position: absolute;
      top: 0px;
      bottom: 0px;
      right: 0px;
      left: 0px;
      z-index: -3;
      width: 100%;
      height: 100%;
    }
`;
const Wrapper = styled(Div)`
    padding: 200px 0 0 0;
    @media (min-width: 767px) {
      padding: ${ props => props.height ?  `${props.height}px 0 0 0` : '200px 0 0 0'};
    }
    &:after {
      background: url(${props => props.image});
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      opacity: ${ props => props.opacity };
      transition: opacity .5s ease-in;
    }
    .page-title-wrapper {
      display: flex;
      align-items: center;
    }
    a.video-play-icons {
      justify-content: center;
      align-items: center;
      display: flex;
      margin-left: 1rem;
    }
    .video-play-icons {
      img {
        width: 30px;
        height: 30px;
      }
    }
`;

const LogoImg = styled.div`
    width: 200px;
    
    position: absolute;
    top: 0;
    left: 0;    
    img {
      width: 100%;
      position: absolute;
      top: 2.5rem;
      left: 2rem;
    }
    
    @media (max-width: 840px) {
      width: 175px;
    }
    
    @media (max-width: 766px) {
      width: 175px;
      img {
        top: 1.75rem;
        left: 1rem;
      }
    }
    
    @media only screen and (max-width: 340px) {
      width: 135px;
    }
    
    :before {
      content: "";
      width: 300px;
      height: 125px;
      background-image: url(${Blur});
      background-repeat: no-repeat;
      background-size: 300px 125px;
      position: absolute;
    }
`;

const PageTitle = styled(Div)`
    opacity: 0.9;
    background-color: ${theme.colors.primary};
    
    @media only screen and (max-width: 340px) {
      h1 {
        font-size: 1.95rem;
      }
    }
`;

const StyledPrimaryButton = styled.div`
   margin-top: 9rem;
`;

const VidWrapper = styled.div`
  position: absolute;
  width: 100vw;
  height: 600px;
  overflow: hidden;
  top: 0;
  
  @media (max-width: 1170px) {
    width: calc(100vw*2);
    left: calc(-50vw);
  }
  @media (max-width: 535px) {
    width: calc(100vw*2.5);
    left: calc(-100vw);
  }
  @media (max-width: 420px) {
    width: calc(100vw*3);
    left: calc(-150vw);
  }
    
  .aspect {
    position: absolute;
    width: 100%;
    height: 0;
    top: -9999px;
    bottom: -9999px;
    margin: auto;
    padding-bottom: 56.25%;
    overflow: hidden;
  }
  .make-height {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .hide-controls {
      box-sizing: content-box;
      position: relative;
      height: 100%;
      width: 100%;
      padding: 55px 97.7777px;
      top: -55px;
      left: -97.7777px;
  }
  iframe {
    transition: opacity .5s ease-in-out;
    opacity: ${props => props.video ? 1 : 0};
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: 0 none;
  }
`;

function Header(props) {
  let formattedPageTitle = props.pageTitle ? props.pageTitle.charAt(0).toUpperCase() + props.pageTitle.slice(1) : null;
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [paused, setPaused] = useState(true);
  const size = useWindowSize();

  useEffect(()=> {
    if (props.heroImgUrl) {
      let img = new Image();
      img.src = `${ baseUrl.slice(0, -1) + props.heroImgUrl }`;
      img.onload = () => {
        setImage(img.src);
        setTimeout( () => setLoaded(true), 500)
      }
    }
  },[props.heroImgUrl]);

  return (
    <Main>
      { !loaded &&
        <div className={'skeleton-hero'}>
          <SkeletonTheme color={theme.colors.primary} highlightColor={"#0e9ede"}>
            <Skeleton
              height={
                props.pageTitle !== 'overview' && props.pageTitle !== 'course' ?
                  size.width > 766 ?
                  '400px'
                  :
                  '500px'
                  :
                  '600px'
              }
              width={'100vw'}
            />
          </SkeletonTheme>
        </div>
      }
      <Wrapper
        image={ image && props.pageTitle !== 'overview' ? image : ''}
        opacity={ image ? 1 : 0}
        h={
          props.pageTitle !== 'overview' && props.pageTitle !== 'course' ?
            size.width > 766 ?
              '400px'
              :
              '500px'
            :
            '600px'
        }
        bg={'transparent'}
        style={{ position: 'relative' }}
        height={ props.height ? props.height : 200 }
      >
        {
          props.pageTitle === 'overview' &&
          <VidWrapper
            video={video}
          >
            <div className={'aspect'}>
              <div className={'make-height'}>
                <div className={'hide-controls'}>
                  <ReactPlayer
                    // url={'https://player.vimeo.com/video/380504864?background=1&muted=1&autoplay=1#t=3m46s&loop=1'}
                    url={ size.width > 540 ? size.width > 720 ? HeroVideoLarge : HeroVideoMedium : HeroVideoSmall}
                    width={'100%'}
                    height={'100%'}
                    playing={!paused}
                    onReady={() => {
                      setVideo(true);
                      setPaused(false)
                    }}
                    controls={false}
                    muted={true}
                    loop={true}
                    playsinline={true}
                  />
                  {/*<iframe onLoad={() => setVideo(true)} frameBorder={0} webkitallowfullscreen mozallowfullscreen allowfullscreen src={'https://player.vimeo.com/video/380504864?background=1&muted=1&autoplay=1#t=3m46s&loop=1'}/>*/}
                </div>
              </div>
            </div>
          </VidWrapper>
        }
        <LogoImg>
          <a target={"_blank"} rel="noopener noreferrer" href={"http://www.olin.edu/"}>
            <img src={Logo} alt={'Olin college for Engineering'}/>
          </a>
        </LogoImg>
        <Container>
          {
            props.pageTitle &&

            <Fade bottom distance={'10px'}>
              <PageTitle
                p={'35px'}
                maxW={'500px'}
                shadow={5}
              >
                <Text
                  tag="h1"
                  textSize="display1"
                  textColor="white"
                >
                  { siteTitle }
                </Text>
                <div className={'page-title-wrapper'}>
                  <Text
                    tag="h2"
                    textSize="heading"
                    textColor="white"
                    textWeight="400"
                  >
                    { formattedPageTitle }
                  </Text>
                {
                  props.pageTitle === 'overview' &&
                  <a className={'video-play-icons'} href={"#"} onClick={e => {
                    e.preventDefault();
                    setPaused(!paused)
                  }}>
                    {
                      paused ?
                        <img alt="play background video" src={PlayIcon} />
                      :
                        <img alt="pause background video" src={PauseIcon} />
                    }
                  </a>
                }
                </div>
              </PageTitle>
            </Fade>

          }
          {
            props.link &&
            <Fade bottom distance={'10px'}>
              <StyledPrimaryButton>
                <PrimaryButton
                  url={props.link.url}
                  text={props.link.text}
                  back={true}
                />
              </StyledPrimaryButton>
            </Fade>
          }
        </Container>
      </Wrapper>
    </Main>
  )
}



export default Header
